import { readingPanels } from "@/mocks/comic";

const featured = {
  title: "纸灯夜行",
  author: "砚生",
  genre: "民俗怪谈",
  score: "9.6",
  tagline: "一盏会自己点亮的旧纸灯，引着少年夜行穿过古镇长街。",
  desc: "深夜的古镇，灯亮了，又灭了。少年跟着一盏纸灯走过长街，每停一盏灯，就听来一段故人往事。墨色浓郁、留白讲究，是目前口碑最高的复古连载。",
  cover:
    "https://readdy.ai/api/search-image?query=vintage%20printed%20comic%20book%20cover%20of%20an%20old%20paper%20lantern%20floating%20over%20a%20misty%20ancient%20alley%20at%20dusk%2C%20mysterious%20folk%20horror%20story%20mood%2C%20retro%20chinese%20ink%20comic%20art%2C%20halftone%20print%20grain%2C%20aged%20cream%20paper%2C%20rust%20red%20and%20warm%20amber%20palette%2C%20no%20text&width=440&height=600&seq=comic-lantern-02&orientation=portrait",
};

export default function Reading() {
  return (
    <section id="reading" className="bg-background-50">
      <div className="container-paper py-14 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.18em] text-primary-600">
              <i className="ri-sparkling-line text-sm leading-none" aria-hidden="true"></i>
              精选阅读
            </span>
            <h2 className="mt-3 font-display text-3xl text-foreground-950 md:text-4xl">
              本期推荐 ·《纸灯夜行》
            </h2>
          </div>
          <span className="seal text-sm">
            <i className="ri-heart-3-fill mr-1 text-base leading-none" aria-hidden="true"></i>
            读者好评
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-5">
          {/* 封面 + 简介 */}
          <article className="lg:col-span-2">
            <div className="flex flex-col gap-6 overflow-hidden rounded-lg border border-background-200 bg-background-100 p-6 sm:flex-row lg:flex-col xl:flex-row">
              <img
                src={featured.cover}
                alt={`《${featured.title}》复古纸质漫画封面`}
                className="h-72 w-full object-cover object-top rounded-md sm:h-56 sm:w-40 shrink-0 lg:h-64 lg:w-full xl:h-56 xl:w-40"
              />
              <div className="flex flex-col justify-center">
                <div className="flex items-center gap-2">
                  <span className="rounded-md bg-primary-600 px-2.5 py-1 text-xs font-medium text-background-50">
                    {featured.genre}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {featured.author} · 连载中 42 话
                  </span>
                </div>
                <h3 className="mt-3 font-display text-2xl text-foreground-950">
                  {featured.title}
                  <span className="ml-2 align-middle text-sm text-accent-600">★ {featured.score}</span>
                </h3>
                <p className="mt-2 text-sm font-medium leading-6 text-foreground-700">
                  {featured.tagline}
                </p>
                <p className="mt-3 text-sm leading-7 text-foreground-600">{featured.desc}</p>
                <a
                  href="#subscribe"
                  className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 sm:w-auto"
                >
                  <i className="ri-book-open-line text-base leading-none" aria-hidden="true"></i>
                  从第一话读起
                </a>
              </div>
            </div>
          </article>

          {/* 分镜图廊 */}
          <div className="lg:col-span-3">
            <div className="grid h-full grid-cols-1 gap-5 sm:grid-cols-3">
              {readingPanels.map((p, idx) => (
                <figure
                  key={p.src}
                  className={`group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 ${
                    idx === 1 ? "sm:translate-y-4" : ""
                  }`}
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={p.src}
                      alt={`《纸灯夜行》分镜：${p.caption}`}
                      className="aspect-[4/3] w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="halftone-light absolute inset-0 opacity-40 mix-blend-multiply"></div>
                  </div>
                  <figcaption className="flex items-center gap-2 px-4 py-3.5 text-xs leading-5 text-foreground-600">
                    <i className="ri-double-quotes-r text-primary-500" aria-hidden="true"></i>
                    {p.caption}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}